module.exports = __webpack_public_path__ + "media/images/undraw/shift/notify-8101f7beb8ca22cabc9832446ddf6c4a.png";